import { render } from "./KryptonRedirectIFrame.vue?vue&type=template&id=bc012472&lang=pug"
import script from "./KryptonRedirectIFrame.vue?vue&type=script&lang=js"
export * from "./KryptonRedirectIFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__